export const ADD_ITEMS_INITIAL_VALUE = { market: {}, fabricType: {}, category: [] };

export const TABLE_VIEW_TYPES = {
	SUMMARY_VIEW: 'SUMMARY_VIEW',
	DETAILS_VIEW: 'DETAILS_VIEW'
};

export const POPUP_VARIENTS = {
	INPUT: 'INPUT',
	DROP_DOWN: 'DROP_DOWN'
};

export const INITIAL_STATE = {
	min: '',
	max: ''
};

export const INITIAL_COMPOSITIONS = {
	composition_1: [
		{ fiberName: '', fiberDetails: {}, percentage: '', id: 1 },
		{ fiberName: '', fiberDetails: {}, percentage: '', id: 2 }
	]
};

export const ENTITY_TYPE = {
	FAVOURITE_FOLDER: 'FAVOURITE_FOLDER',
	COLLECTION: 'COLLECTION'
};

export const UPDATE_ENTITY_TYPE = {
	QUANTITY: 'QUANTITY',
	PRICE: 'PRICE',
	GSM: 'GSM',
	FIT_TYPE: 'FIT_TYPE',
	CONSTRUCTION: 'CONSTRUCTION',
	COMPOSITION: 'COMPOSITION',
	REMARKS: 'REMARKS'
};

export const COLOR_CODES_MEN = {
	knit: '#AED7FF',
	woven: '#C2E1FF',
	denim: '#D7EBFF'
};

export const COLOR_CODES_WOMEN = {
	knit: '#FFBCE0',
	woven: '#FFCDE8',
	denim: '#FFDEEF'
};
